<template>
	<div>
		<el-table class="qcTable" :data="qcplanList" v-loading="loading">
			<el-table-column prop="Id" label="方案编号"></el-table-column>
			<el-table-column prop="Name" label="名称"></el-table-column>
			<el-table-column prop="Type" label="类型">
				<template slot-scope="scope">
					<span v-if="scope.row.Type==1" title="影像">影像</span>
					<span v-else-if="scope.row.Type==2" title="报告">报告</span>
					<span v-else-if="scope.row.Type==3" title="影像和报告">影像和报告</span>
					<span v-else-if="scope.row.Type==4" title="影像报告和病史">影像报告和病史</span>
					<span v-else title="全部">全部</span>
				</template>
			</el-table-column>
			<el-table-column prop="Mode" label="模式">
				<template slot-scope="scope">
					<span v-show="scope.row.Mode == 1">
                                加分
                            </span>
					<span v-show="scope.row.Mode == 2">
                                减分
                            </span>
				</template>
			</el-table-column>
			<el-table-column prop="ModalityType" label="设备">
				<template slot-scope="scope">
					{{scope.row.ModalityType}}
				</template>
			</el-table-column>
			<el-table-column prop="CreateDt" min-width="100" :formatter="formattertime" label="创建时间"></el-table-column>
			<el-table-column prop="Enable" label="状态">
				<template slot-scope="scope">
					<span v-show="scope.row.Enable == 0">
                                禁用
                            </span>
					<span v-show="scope.row.Enable == 1">
                                启用
                            </span>
				</template>
			</el-table-column>
			<el-table-column prop="" label="操作" fixed="right" width="180">
				<template slot-scope="scope">
					<span class="table-task-btn detail" @click="handleClick(scope.row)">编辑</span>
					<span class="table-task-btn delete" @click="deletes(scope.row)">删除</span>
				</template>
			</el-table-column>

		</el-table>
	</div>
</template>

<script>
	import { mapState, mapActions, mapMutations } from 'vuex'
	export default {
		computed: {
			...Vuex.mapState('managerPlan', ['qcplanList', 'QCPlanGuidId','loading'])
		},
		methods: {
			...Vuex.mapMutations('managerPlan', ['setSplitScreen']),
			...Vuex.mapActions('managerPlan', ['DeleteQCPlan', 'GetQCPlan']),
			formattertime(row, column, cellValue){
				if (cellValue!=''&&cellValue!=null) {
					return cellValue.substring(0,cellValue.length-3);
				}else{
					return cellValue;
				}
			},
			handleClick(arr) {
				this.QCPlanGuidId.QCPlanGuid = arr.QCPlanGuid;
				this.GetQCPlan()
				this.$router.push("/home/plan/newSchemeDetails");
			},
			deletes(arr) {
				this.QCPlanGuidId.UniqueId = arr.QCPlanGuid;
				this.$confirm('是否确定删除？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
				}).then(() => {
					this.DeleteQCPlan()
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});

			}

		}

	}
</script>